(function () {
  'use strict';

  var STEPS = ['brand', 'equipment', 'model'];
  var STEP_LABELS = ['Brand', 'Equipment', 'Model'];

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getData() {
    return window.TCB_MANUAL_FINDER_DATA || {};
  }

  function buildExpertUrl(state) {
    var params = new URLSearchParams({
      topic: 'documents',
      brand: state.brand || '',
      equipment: state.equipmentLabel || '',
      model: state.model || ''
    });
    return '/pages/contact?' + params.toString() + '#tcb-contact-form';
  }

  function ManualFinder(root) {
    this.root = root;
    this.shell = root.querySelector('[data-tcb-manual-shell]');
    this.flowMount = root.querySelector('[data-tcb-manual-flow]');
    this.resultsMount = root.querySelector('[data-tcb-manual-results]');
    this.stepIndex = 0;
    this.state = { brand: '', equipment: '', equipmentLabel: '', model: '' };
    this.bind();
    this.render();
  }

  ManualFinder.prototype.bind = function () {
    var self = this;
    this.root.querySelector('[data-tcb-manual-start]').addEventListener('click', function () {
      self.shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
      self.stepIndex = 0;
      self.state = { brand: '', equipment: '', equipmentLabel: '', model: '' };
      self.resultsMount.hidden = true;
      self.shell.hidden = false;
      self.render();
    });
  };

  ManualFinder.prototype.render = function () {
    var self = this;
    var data = getData();
    var stepId = STEPS[this.stepIndex];
    var progress = STEP_LABELS.map(function (label, i) {
      return '<span class="' + (i === self.stepIndex ? 'is-active' : '') + '">' + escapeHtml(label) + '</span>';
    }).join('');

    var body = '';
    if (stepId === 'brand') {
      body = this.renderOptions((data.brands || []).map(function (b) { return { value: b, label: b }; }), 'brand');
    } else if (stepId === 'equipment') {
      body = this.renderOptions((data.equipmentTypes || []).map(function (e) {
        return { value: e.id, label: e.label };
      }), 'equipment');
    } else if (stepId === 'model') {
      body =
        '<h2>Enter model number</h2>' +
        '<p>We will show available manual types or connect you with our team for the document.</p>' +
        '<input class="tcb-manual-finder-input" type="text" data-model-input placeholder="e.g. T300, 2008CS" value="' +
        escapeHtml(this.state.model) +
        '" aria-label="Model number">' +
        '<div class="tcb-manual-finder-nav">' +
        '<button type="button" class="tcb-page-btn tcb-page-btn--secondary" data-back>Back</button>' +
        '<button type="button" class="tcb-page-btn tcb-page-btn--primary" data-show-results>Find manuals</button>' +
        '</div>';
    }

    this.flowMount.innerHTML =
      '<div class="tcb-manual-finder-progress" aria-label="Progress">' + progress + '</div>' +
      '<div class="tcb-manual-finder-step">' + body + '</div>';

    this.flowMount.querySelectorAll('[data-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var value = btn.getAttribute('data-value');
        var label = btn.getAttribute('data-label');
        if (key === 'equipment') {
          self.state.equipment = value;
          self.state.equipmentLabel = label;
        } else {
          self.state[key] = value;
        }
        self.stepIndex += 1;
        self.render();
      });
    });

    var back = this.flowMount.querySelector('[data-back]');
    if (back) back.addEventListener('click', function () { self.stepIndex -= 1; self.render(); });

    var show = this.flowMount.querySelector('[data-show-results]');
    if (show) {
      show.addEventListener('click', function () {
        var input = self.flowMount.querySelector('[data-model-input]');
        self.state.model = (input && input.value || '').trim();
        self.showResults();
      });
    }
  };

  ManualFinder.prototype.renderOptions = function (options, key) {
    var self = this;
    var gridClass = options.length > 6 ? ' tcb-manual-finder-options--grid' : '';
    var title = key === 'brand' ? 'What brand is your equipment?' : 'What type of equipment?';
    var html =
      '<h2>' + escapeHtml(title) + '</h2>' +
      '<div class="tcb-manual-finder-options' + gridClass + '">';
    options.forEach(function (opt) {
      html +=
        '<button type="button" class="tcb-manual-finder-option" data-option data-key="' +
        escapeHtml(key) +
        '" data-value="' +
        escapeHtml(opt.value) +
        '" data-label="' +
        escapeHtml(opt.label) +
        '">' +
        escapeHtml(opt.label) +
        '</button>';
    });
    html += '</div>';
    if (self.stepIndex > 0) {
      html +=
        '<div class="tcb-manual-finder-nav">' +
        '<button type="button" class="tcb-page-btn tcb-page-btn--secondary" data-back>Back</button>' +
        '</div>';
    }
    return html;
  };

  ManualFinder.prototype.showResults = function () {
    var data = getData();
    var expertUrl = buildExpertUrl(this.state);
    var manualItems = (data.manualTypes || []).map(function (m) {
      return (
        '<li><span>' +
        escapeHtml(m.label) +
        '</span><a class="tcb-page-btn tcb-page-btn--secondary" href="' +
        escapeHtml(expertUrl) +
        '">Request document</a></li>'
      );
    }).join('');

    this.shell.hidden = true;
    this.resultsMount.hidden = false;
    this.resultsMount.innerHTML =
      '<div class="tcb-wrap">' +
      '<h2>Manuals for ' +
      escapeHtml(this.state.brand) +
      ' ' +
      escapeHtml(this.state.equipmentLabel) +
      (this.state.model ? ' · ' + escapeHtml(this.state.model) : '') +
      '</h2>' +
      '<p class="tcb-manual-finder-summary">Select a document type to request from our team, or browse equipment guides for maintenance content.</p>' +
      '<ul class="tcb-manual-finder-list">' +
      manualItems +
      '</ul>' +
      '<div class="tcb-manual-finder-actions">' +
      '<a class="tcb-page-btn tcb-page-btn--primary" href="/pages/equipment-guides">Browse equipment guides</a>' +
      '<a class="tcb-page-btn tcb-page-btn--secondary" href="' +
      escapeHtml(expertUrl) +
      '">Talk to an expert</a>' +
      '<button type="button" class="tcb-page-btn tcb-page-btn--secondary" data-restart>Start over</button>' +
      '</div>' +
      '<div class="tcb-manual-finder-note">' +
      '<strong>Coming soon:</strong> Direct PDF downloads and indexable manual pages (e.g. Tennant T300 parts manual) for SEO and faster self-service.' +
      '</div>' +
      '</div>';

    var self = this;
    this.resultsMount.querySelector('[data-restart]').addEventListener('click', function () {
      self.root.querySelector('[data-tcb-manual-start]').click();
    });

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'manual_lookup_completed',
        manual_brand: self.state.brand,
        manual_equipment: self.state.equipment,
        manual_model: self.state.model
      });
    }
  };

  function boot() {
    var root = document.querySelector('[data-tcb-manual-finder]');
    if (!root) return;
    var url = window.TCB_MANUAL_FINDER_DATA_URL;
    if (!url) {
      new ManualFinder(root);
      return;
    }
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        window.TCB_MANUAL_FINDER_DATA = data;
        new ManualFinder(root);
        if (window.dataLayer) window.dataLayer.push({ event: 'manual_lookup_started' });
      })
      .catch(function () {
        new ManualFinder(root);
      });
  }

  document.addEventListener('DOMContentLoaded', boot);
})();
